export default "__VITE_ASSET__BqwwRbtu__"